export default __webpack_public_path__ + "static/media/ddsu5168_background.e265e5db.png";